import Gobalstore from "../index";
export const actions = {
  getSector: function (localStore) {
    this.axios({
      method: "GET",
      url: "/business/guarded/sector",
    }).then(function (response) {
      localStore.commit("setSector", response.data);
    });
  },
};
